import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Added useLocation
import { useUser } from "../../Context/UserContext";
import logoImage from "../../assets/images/LogoImage.svg";
import EditIcon from "../../assets/images/ProfileEditIcon.svg";
import DashboardIcon from "../../assets/images/DashboardIcon.svg";
import DashBoardIconInactive from "../../assets/images/DashBoardIconInactive.svg";
import ContentIcon from "../../assets/images/ContentIcon.svg";
import AnalyticsIcon from "../../assets/images/AnalyticsIcon.svg";
import AnalyticsIconInactive from "../../assets/images/AnalyticsIconInactive.svg";
import EarningsIcon from "../../assets/images/EarningsIcon.svg";
import ContentIconInactive from "../../assets/images/ContentIconInactive.svg";
import EarningsIconInactive from "../../assets/images/EarningsIconInactive.svg";
import UserIcon from "../../assets/images/UserIcon.svg";
import AllComments from "../../assets/images/AllComments.svg";
import chevronRight from "../../assets/images/chevron-right-profile.svg";
import LogoutIcon from "../../assets/images/LogoutIcon.svg";
import Notification from "../../assets/images/Notification.svg";
import NotificationIcon from "../../assets/images/NotificationIcon.svg";
import { toast } from "react-hot-toast";
import { showToast } from "../../utils/toastUtils";
import {
  callApi,
  clearTokens,
  clearVerificationToken,
} from "../../utils/apiService";

import "./Header.css";
import { videoCreatorEndPoint } from "../../Constants/constants";

const Header = () => {
  const [profileOpen, setProfileOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationPreference, setNotificationPreference] = useState(
    localStorage.getItem("notificationPreference") || "Allow",
  );

  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const { user, clearUserData } = useUser();

  console.log("user", user);

  const toggleProfile = () => setProfileOpen(!profileOpen);
  const handleNavClick = (path) => {
    navigate(path);
    setProfileOpen(false);
  };

  const handleEditClick = () => {
    navigate("/profile-edit");
  };

  const handleNotificationChange = (value) => {
    setNotificationPreference(value);
    localStorage.setItem("notificationPreference", value);
    setNotificationOpen(false);
  };
  // Check if current route matches nav item path
  const isActive = (item) => {
    if (item.activePaths) {
      return item.activePaths.includes(location.pathname);
    }

    return location.pathname === item.path;
  };

  const Avatar = ({ isClickable = false }) => {
    if (user?.profileUrl) {
      return (
        <div className={`relative ${isClickable ? "cursor-pointer" : ""}`}>
          <img
            src={user?.profileUrl}
            alt={user?.fullName}
            className={` ${isClickable ? "header-profile-avatar-clickable" : "header-profile-avatar"}`}
          />
          {isClickable && (
 
              <img
              className="absolute -bottom-1 -right-1 text-white transition-all duration-200"
                src={EditIcon}
                alt="Edit"
                style={{ width: "25px", height: "25px" }}
              onClick={handleEditClick}
              />
          )}
        </div>
      );
    }
    return (
      <div className={`relative ${isClickable ? "cursor-pointer" : ""}`}>
        <div
          className={` ${isClickable ? "profile-initials-clickable" : "profile-initials"}`}
        >
          {user?.fullName
            .split(" ")
            .map((n) => n[0])
            .slice(0, 1)
            .join("")}
        </div>
        {isClickable && (
          <button
            onClick={handleEditClick}
            className="absolute -bottom-1 -right-1 text-white transition-all duration-200"
            title="Edit profile"
          >
            <img
              src={EditIcon}
              alt="Edit"
              style={{ width: "25px", height: "25px" }}
            />
          </button>
        )}
      </div>
    );
  };

  const navItems = [
    {
      path: "/dashboard",
      title: "Dashboard",
      iconType: "dashboard",
      activePaths: ["/dashboard", "/upload-story", "/upload-video", "/upload-reel", "/subscribers","/view-awaiting-list"],
    },
    {
      path: "/content",
      title: "Content",
      iconType: "play",
      activePaths: ["/content", "/video-insights"],
    },
    {
      path: "/content-analytics",
      title: "Analytics",
      iconType: "analytics",
    },
    {
      path: "/earnings",
      title: "Earnings",
      iconType: "earnings",
    },
  ];

  const handleLogout = async (e) => {
    e.stopPropagation();

    try {
      const response = await callApi(
        `${videoCreatorEndPoint}auth/logout`,
        "POST",
      );

      if (response?.status) {
        // Clear Context
        clearUserData();

        // Clear Tokens
        clearTokens();
        clearVerificationToken();

        // Clear any other local storage data if required
        localStorage.clear();

        navigate("/login", { replace: true });
        showToast("success", "User logged out successfully", 100);
      }
    } catch (error) {
      showToast(
        "error",
        error?.message || "Failed to logout. Please try again.",
      );
    }
  };
  return (
    <header className="dashboard-header">
      <img
        src={logoImage}
        alt="AstroCure"
        className="dashboard-logo-image"
        onClick={() => navigate("/dashboard")}
        style={{ cursor: "pointer" }}
      />

      <nav className="header-nav-section nav-menu">
        {navItems.map((item) => (
          <button
            key={item.path}
            className={`header-nav-link ${isActive(item) ? "active" : ""} ${item.iconType === "play" ? "btn-width" : ""} `}
            title={item.title}
            onClick={() => handleNavClick(item.path)}
          >
            {item.iconType === "dashboard" ? (
              isActive(item) ? (
                <img
                  src={DashboardIcon}
                  alt="Dashboard"
                  className="w-6 h-6 dash-img"
                />
              ) : (
                <img
                  src={DashBoardIconInactive}
                  alt="Dashboard"
                  className="w-6 h-6 dash-img"
                />
              )
            ) : item.iconType === "play" ? (
              isActive(item) ? (
                <img src={ContentIcon} alt="Content" className="w-6 h-6" />
              ) : (
                <img
                  src={ContentIconInactive}
                  alt="Content"
                  className="w-6 h-6"
                />
              )
            ) : item.iconType === "analytics" ? (
              isActive(item) ? (
                <img src={AnalyticsIcon} alt="Analytics" className="w-6 h-6" />
              ) : (
                <img
                  src={AnalyticsIconInactive}
                  alt="Analytics"
                  className="w-6 h-6"
                />
              )
            ) : item.iconType === "earnings" ? (
              isActive(item) ? (
                <img
                  src={EarningsIcon}
                  alt="Earnings"
                  className="dash-img"
                  style={{ width: "22px", height: "22px" }}
                />
              ) : (
                <img
                  src={EarningsIconInactive}
                  alt="Earnings"
                  style={{ width: "22px", height: "22px" }}
                />
              )
            ) : null}
            <p
              className={`nav-title ${item.iconType === "earnings" || item.iconType === "dashboard" ? "dash-title" : ""} ${item.iconType === "play" ? "pr-4" : item?.iconType === "analytics" ? "pr-3" : ""}`}
            >
              {item.title}
            </p>
          </button>
        ))}
        <div className="pl-5 notification-icon-container">
          <img
            src={NotificationIcon}
            alt="NotificationIcon"
            onClick={() => navigate("/notifications")}
          />
        </div>
      </nav>

      <div className="profile-container" onClick={toggleProfile}>
        <Avatar />
        <svg
          className="dropdown-arrow"
          viewBox="0 0 24 24"
          width="16"
          height="16"
        >
          <path d="M7 10l5 5 5-5z" fill="#64748b" />
        </svg>

        {profileOpen && (
          <div className="profile-dropdown">
            <div className="profile-header">
              <Avatar isClickable={true} />
              <div>
                <div className="profile-drop-name-full">{user?.fullName}</div>
                <div className="profile-drop-email">{user?.email}</div>
              </div>
            </div>
            <div className="profile-dropdown-content">
              <div className="profile-container-img">
                <img src={UserIcon} alt="profile" className="profile-icon"/>
                <button
                  className="dropdown-item"
                  onClick={() => handleNavClick("/profile")}
                >
                  My Profile
                </button>
                <img src={chevronRight} alt="chevron-right" />
              </div>
              <div className="profile-container-img">
                <img src={AllComments} alt="comments" className="profile-icon" />
                <button
                  className="dropdown-item active-comment"
                  onClick={() => handleNavClick("/comment-moderation")}
                >
                  All Comments
                  {/* <div className="badge">3</div> */}
                </button>
                <img src={chevronRight} alt="chevron-right" />
              </div>
              <div className="profile-container-img notification notification-wrapper">
                <img src={Notification} alt="notification" className="profile-icon" />

                <button
                  type="button"
                  className="dropdown-item color-black notification-trigger"
                  onClick={(e) => {
                    e.stopPropagation();
                    setNotificationOpen(!notificationOpen);
                  }}
                >
                  <span>Notification</span>

                  <div className="notification-right">
                    <span className="notification-value">
                      {notificationPreference}
                    </span>
                  </div>
                </button>

                {notificationOpen && (
                  <div
                    className="notification-dropdown"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className={`notification-option ${
                        notificationPreference === "Allow" ? "selected" : ""
                      }`}
                      onClick={() => handleNotificationChange("Allow")}
                    >
                      Allow
                    </button>

                    <button
                      className={`notification-option ${
                        notificationPreference === "Mute" ? "selected" : ""
                      }`}
                      onClick={() => handleNotificationChange("Mute")}
                    >
                      Mute
                    </button>
                  </div>
                )}
              </div>
              <div className="profile-container-img logout">
                <img src={LogoutIcon} alt="logout" className="profile-icon" />
                <button
                  className="dropdown-item logout color-black"
                  onClick={handleLogout}
                >
                  Log out
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
